export const TECHNICAL_BREAK_SETTING_KEY = 'technicalBreak';

/** Czy ustawiona przerwa „do daty” już minęła (enabled=true w bazie, ale czas się skończył). */
export function isTechnicalBreakTimedExpired(config) {
  if (!config || config.enabled !== true) return false;
  if (config.durationMode !== 'timed' || !config.endsAt) return false;
  const endsAtMs = new Date(config.endsAt).getTime();
  return !Number.isNaN(endsAtMs) && Date.now() >= endsAtMs;
}

export function buildDisabledTechnicalBreakValue(config = {}) {
  return {
    enabled: false,
    message: typeof config.message === 'string' ? config.message : '',
    durationMode: 'indefinite',
    endsAt: null,
  };
}

/** Wartość do zapisu / formularza po wygaśnięciu przerwy czasowej. */
export function normalizeTechnicalBreakValue(raw) {
  if (isTechnicalBreakTimedExpired(raw)) {
    return buildDisabledTechnicalBreakValue(raw);
  }
  return raw ?? {};
}
